import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from "@react-google-maps/api";
import { Autocomplete as GoogleAutocomplete } from "@react-google-maps/api";
import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Typography,
  Grid,
  Avatar,
  CircularProgress,
  TextField,
  Autocomplete,
  Switch,
  FormGroup,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { type Dayjs } from "dayjs";
import {
  ApiGetShopperVenueMap,
  ApiGetShopperPopUpDetails,
  ApiPutShopperDetails,
  ApiGetVenuePreviousReports,
  ApiGetClientEntityByClientGroupId,
} from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
import { InfoBox } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const center = {
  lat: -25.2744,
  lng: 133.7751,
};

// States options array
const stateOptions = [
  { label: "Victoria", value: "VIC" },
  { label: "Western Australia", value: "WA" },
  { label: "South Australia", value: "SA" },
  { label: "Queensland", value: "QLD" },
  { label: "Australian Capital Territory", value: "ACT" },
  { label: "New South Wales", value: "NSW" },
  { label: "Tasmania", value: "TAS" },
  { label: "Northern Territory", value: "NT" },
];

// Types for API response
interface VenueMapData {
  clientGroupName: string;
  entityTypeId: number;
  entityTypeName: string;
  clientEntityId: number;
  entityName: string;
  venueId: number;
  venueName: string;
  lat: string;
  lng: string;
  logo: string;
}

interface UserData {
  user_userId: number;
  user_firstName: string;
  user_lastName: string;
  user_contactNo: string;
  user_emailId: string;
  user_dob: string;
  user_latitude: string | null;
  user_longitude: string | null;
  user_userName: string;
  age: string | null;
  userStatusName: string;
}

interface ApiResponse {
  status: boolean;
  message: string;
  data: {
    venueMapDatas: VenueMapData[];
    userData: {
      status_filtered_users: UserData[];
    };
  };
}

// Interface for shopper details API response
interface ShopperDetails {
  contactDetails: {
    age: string;
    email: string;
    phone: string;
  };
  currentMonthAllocationCounts: {
    MM: number;
    BLOOMS: number;
    ALDI: number;
    TRANSPORT: number;
  };
  history: {
    totalReports: number;
    aldi: number;
    blooms: number;
    mm: number;
    beacon: number;
  };
  stats: {
    memberSince: string;
    lastReportRating: number;
    lastMonth: string;
    overallRating: string;
  };
  editorComment: string;
  shopperNotes: string[];
  trainingNotes: string;
}

// Marker interface for map
interface MapMarker {
  id: number;
  name: string;
  lat: number;
  lng: number;
  type: string;
  logo: string;
  entityName: string;
  age: any;
  clientGroupName: string;
  index: number;
  dob: any;
  emailId: string;
  contactNo: string;
  venuePriceDisplay?: string;
}

const ShopperVenueMap: React.FC = () => {
  const [selectedMarker, setSelectedMarker] = useState<MapMarker | null>(null);
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(dayjs());
  const [loading, setLoading] = useState<boolean>(false);
  const [mapMarkers, setMapMarkers] = useState<MapMarker[]>([]);
  const [shopperMarkers, setShopperMarkers] = useState<MapMarker[]>([]);
  //const [selectedStates, setSelectedStates] = useState<string[]>([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedStateValue, setSelectedValue] = useState();

  // State for shopper details
  const [shopperDetails, setShopperDetails] = useState<any>(null);
  const [loadingShopperDetails, setLoadingShopperDetails] =
    useState<boolean>(false);
  const [shopperNotes1, setShopperNotes1] = useState("");
  const [ShopperName, setShopperName] = useState("");
  const [trainingNotes, setTrainingNotes] = useState("");
  const [centermap, setcentermap] = useState(center)
  const [clientEntityList, setClientEntityList] = useState<any>([])


  // State for venue details
  const [venueDetails, setVenueDetails] = useState<any>(null);
  const [loadingVenueDetails, setLoadingVenueDetails] =
    useState<boolean>(false);
  const mapRef = useRef<any>(null);


  const [checkboxStates, setCheckboxStates] = useState({
    shopperActive18: false,
    shopperActiveOther: false,
    shopperInactive: false,
    // showAldi: false,
    showAldiAudit: false,
    showAldiLiquorID: false,
    showBloom: false,
    showMM: false,
    showJbHifi: false,
    showExtended: false,
  });
  const [staticLineInserted, setStaticLineInserted] = useState(false);
  const [staticLineInserted2, setStaticLineInserted2] = useState(false);
  const shoppernoteRef = useRef<HTMLTextAreaElement | null>(null);
  const trainingnoteRef = useRef<HTMLTextAreaElement | null>(null);
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCmcI0swO1MNjQYUD7qktNT78-cDMBoi44",
  });
  const [autocomplete, setAutocomplete] = useState<google.maps.places.Autocomplete | null>(null);
  const [searchResult, setSearchResult] = useState<string>("");
  const inputRef = useRef<HTMLInputElement>(null);
  const [pending, setPending] = useState<boolean>(false);
  const omsRef = useRef<any>(null);
  const [openuserDetails, setopenuserdetails] = useState(false);

  // const onMapLoad = async (map) => {
  //   mapRef.current = map;

  //   const { default: OverlappingMarkerSpiderfier } = await import(
  //     "overlapping-marker-spiderfier"
  //   );
  //   const oms = new OverlappingMarkerSpiderfier(map, {
  //     keepSpiderfied: true,
  //     circleSpiralSwitchover: 12,
  //     nearbyDistance: 100,
  //     markersWontMove: true,
  //     markersWontHide: true,
  //   });
  //   let isSpiderfied = false;
  //   oms.legWeight = 4;
  //   oms.addListener("spiderfy", (markers: any) => {
  //     isSpiderfied = true;
  //   });

  //   oms.addListener("unspiderfy", (markers: any) => {
  //     isSpiderfied = false;
  //   });

  //   oms.addListener("click", (markerInstance: any, event: any) => {
  //     const markerData = markerInstance.customData;

  //     if (!markerData) {
  //       console.error("No marker data found!");
  //       return;
  //     }
  //     const nearbyMarkers = oms.markersNearMarker(markerInstance, false);
  //     if (nearbyMarkers.length > 1 && !isSpiderfied) {
  //       return
  //     } else {
  //       handleMarkerClick(markerData);
  //     }
  //   });


  //   omsRef.current = oms;
  // };

  const onMapLoad = async (map) => {
  mapRef.current = map;
  const { default: OverlappingMarkerSpiderfier } = await import(
    "overlapping-marker-spiderfier"
  );
  const oms = new OverlappingMarkerSpiderfier(map, {
    keepSpiderfied: true,
    circleSpiralSwitchover: 12,
    nearbyDistance: 100,
  });

  let isSpiderfied = false;
  let preventUnspiderfy = false;

  oms.legWeight = 4;

  oms.addListener("spiderfy", (markers: any) => {
    isSpiderfied = true;
  });

  oms.addListener("unspiderfy", (markers: any) => {
    if (!preventUnspiderfy) {
      isSpiderfied = false;
    }
  });

  oms.addListener("click", (markerInstance: any) => {
  const markerData = markerInstance.customData;

  if (!markerData) {
    console.error("No marker data found!");
    return;
  }

  // SINGLE source of truth
  setSelectedMarker(markerData);

  // Call APIs based on type
  if (markerData.entityName === "Shopper") {
    fetchShopperDetails(markerData.id);
  } else {
    fetchVenueReportDetails(markerData);
  }
});


  // Add a listener to close spider when clicking elsewhere on the map
  map.addListener("click", () => {
    if (isSpiderfied && !preventUnspiderfy) {
      oms.unspiderfy();
    }
  });

  omsRef.current = oms;
};

  const handleGetClientList = async () => {
    const data = `?ClientGroupName=ALDI`
    try {
      const res: any = await ApiGetClientEntityByClientGroupId(data)
      setClientEntityList(res.data)
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }

  useEffect(() => {
    handleGetClientList()
  }, [])

  useEffect(() => {
    const loadAutocomplete = async () => {
      // Add a small delay to ensure the input is rendered
      setTimeout(() => {
        if (!window.google) {
          console.error("Google Maps API is not loaded.");
          return;
        }

        if (!inputRef.current) {
          console.error("Input reference is null.");
          return;
        }

        try {
          const autocompleteInstance = new window.google.maps.places.Autocomplete(
            inputRef.current,
            {
              types: ["geocode"],
              componentRestrictions: { country: "AU" }, // Restrict to Australia
            }
          );

          autocompleteInstance.addListener("place_changed", () => {
            const place = autocompleteInstance.getPlace();

            if (!place || !place.formatted_address) {
              console.warn("No address found.");
              return;
            }

            setSearchResult(place.formatted_address);

            if (place.geometry?.location) {
              const location = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
              };
              setcentermap(location);

              // Zoom in to the selected location
              if (mapRef.current) {
                mapRef.current.setCenter(location);
                mapRef.current.setZoom(15); // Higher zoom level for closer view
              }
            }
          });
        } catch (error) {
          console.error("Error initializing autocomplete:", error);
        }
      }, 100);
    };

    loadAutocomplete();
  }, []);

  useEffect(() => {
    if (!searchResult && mapRef.current) {
      mapRef.current.setZoom(4); // Reset to default zoom when search is cleared
    }
  }, [searchResult]);

  // Function to call API
  const fetchMapData = async () => {
    try {
      setLoading(true);
      // Build parameters
      const paramsAttachment: any = [];

      // Add selected states if any are selected
      if (selectedState != "") {
        // Pass raw string, no encoding
        paramsAttachment.push(`state=${selectedState}`);
      } else {
        toast.error("Please select state");
        return;
      }

      const selectedClientEntityIds: any = [];
      if (checkboxStates.showAldiAudit) {
        const auditEntity = clientEntityList.find((entity: any) => entity.entityName === "Audit");
        if (auditEntity) selectedClientEntityIds.push(auditEntity.clientEntityId);
      }
      if (checkboxStates.showAldiLiquorID) {
        const liquorEntity = clientEntityList.find((entity: any) => entity.entityName === "Liquor ID");
        if (liquorEntity) selectedClientEntityIds.push(liquorEntity.clientEntityId);
      }

      const selectClientEntityId = selectedClientEntityIds.join(",");
      if (selectClientEntityId) {
        paramsAttachment.push(`clientEntityId=${selectClientEntityId}`);
      }


      // Add client groups if any are selected
      const selectedClientGroups: any = [];
      // if (checkboxStates.showAldi) selectedClientGroups.push("ALDI");
      if (checkboxStates.showBloom) selectedClientGroups.push("BLOOMS");
      if (checkboxStates.showMM) selectedClientGroups.push("MM");
      if (checkboxStates.showJbHifi) selectedClientGroups.push("JBHIFI");
      if (checkboxStates.showExtended) selectedClientGroups.push("EXTENDED");

      const selectClientGroup = selectedClientGroups.join(","); // e.g., "ALDI,BLOOMS"
      if (selectClientGroup) {
        paramsAttachment.push(`ClientGroupName=${selectClientGroup}`);
      }

      const selectedShoppers: any = [];
      if (checkboxStates.shopperActive18) selectedShoppers.push("active");
      if (checkboxStates.shopperActiveOther) selectedShoppers.push("active");
      if (checkboxStates.shopperInactive) selectedShoppers.push("inActive");

      const selectedShopper = selectedShoppers.join(",");
      if (selectedShopper) {
        paramsAttachment.push(`userStatus=${selectedShopper}`);
      }

      if (pending) {
        paramsAttachment.push(`isPending=true`);
      }
      else {
        paramsAttachment.push(`isPending=false`)
      }

      // Add month and year from selectedDate
      if (selectedDate) {
        const month = selectedDate.month() + 1; // dayjs months are 0-indexed
        const year = selectedDate.year();
        paramsAttachment.push(`month=${month}`);
        paramsAttachment.push(`year=${year}`);
      }

      // Construct the query string
      const data =
        paramsAttachment.length > 0 ? `?${paramsAttachment.join("&")}` : "";

      // Replace with your actual API endpoint
      const response = await ApiGetShopperVenueMap(data);

      if (!response.status) {
        toast.error("Failed to load data");
      }

      //const apiData: ApiResponse = await response.json()
      let venueMarkers: MapMarker[] = [];
      if (response.status && response.data) {
        // Map venue data to markers
        if (response.data.venueMapDatas) {
          venueMarkers = response.data.venueMapDatas.map((venue: any, index: any) => ({
            id: venue.venueId,
            name: venue.venueName,
            lat: Number(venue.lat),
            lng: Number(venue.lng),
            type: venue.clientGroupName.toLowerCase(),
            logo: getVenueIcon(venue.clientGroupName),
            entityName: venue.entityName,
            clientGroupName: venue.clientGroupName,
            venuePriceDisplay: venue.venuePriceDisplay,
            index: index, // Add index to venue marker
          }));

          setMapMarkers(venueMarkers);
        }
        // Map user data to markers (for shoppers)
        if (response.data.userData) {
          const userMarkers: MapMarker[] =
            response.data.userData.status_filtered_users
              .filter((user: any) => user.user_latitude && user.user_longitude)
              .map((user: any, userIndex: any) => ({
                id: user.user_userId,
                name:
                  `${user.user_firstName} ${user.user_lastName}`.trim() ||
                  user.user_userName,
                lat: Number(user.user_latitude!),
                lng: Number(user.user_longitude!),
                type: user.userStatusName,
                logo: getShopperIcon(user.userStatusName, user.age),
                age: user.age,
                entityName: "Shopper",
                clientGroupName: user.userStatusName,
                dob: user.user_dob,
                emailId: user.user_emailId,
                contactNo: user.user_contactNo,
                index: venueMarkers.length + userIndex, // Offset to avoid overlap
              }));

          setShopperMarkers(userMarkers);
        }
      }
    } catch (error) {
      console.error("Error fetching map data:", error);
      toast.error("Error loading map data");
    } finally {
      setLoading(false);
    }
  };

  // Function to fetch shopper details
  const fetchShopperDetails = async (shopperId: number) => {
    try {
      setLoadingShopperDetails(true);
      // Reset previous shopper details
      setShopperDetails(null);
      setShopperNotes1("");
      setTrainingNotes("");

      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // Months are zero-based, so add 1
      const currentYear = currentDate.getFullYear();

      const data = `?userId=${shopperId}&currentMonth=${currentMonth}&currentYear=${currentYear}`;

      // Call API to get shopper details
      const response = await ApiGetShopperPopUpDetails(data);

      if (!response.status) {
        toast.error("Failed to load shopper details");
        return;
      }

      // Set shopper details from API response
      setShopperDetails(response.data);

      // Set notes from API response
      if (response.data) {
        setShopperName(`${response.data.firstName} ${response.data.lastName}`)
        setShopperNotes1(response.data.shopperOtherDetail.shopperNotes || "");
      }
      if (response.data) {
        setTrainingNotes(response.data.shopperOtherDetail.trainingNotes || "");
      }
    } catch (error) {
      console.error("Error fetching shopper details:", error);
      toast.error("Error loading shopper details");
    } finally {
      setLoadingShopperDetails(false);
    }
  };

  // Function to fetch venue details
  const fetchVenueReportDetails = async (marker: MapMarker) => {
    try {
      setLoadingVenueDetails(true);
      // Reset previous venue details
      setVenueDetails(null);

      const data = `?venueId=${marker.id}&clientGroupName=${marker.clientGroupName}`;

      //Call API to get venue details - replace with your actual API function
      const response = await ApiGetVenuePreviousReports(data); // You'll need to import this

      if (!response.status) {
        toast.error("Failed to load venue details");
        return;
      }

      // Set venue details from API response
      setVenueDetails(response.data);
    } catch (error) {
      console.error("Error fetching venue details:", error);
      toast.error("Error loading venue details");
    } finally {
      setLoadingVenueDetails(false);
    }
  };

  // Function to handle marker click
  const handleMarkerClick = (marker: MapMarker) => {
    setSelectedMarker(marker);
    setStaticLineInserted(false)
    setStaticLineInserted2(false)

    // If it's a shopper marker, fetch shopper details
    if (marker.entityName === "Shopper") {
      fetchShopperDetails(marker.id);
    } else {
      fetchVenueReportDetails(marker);
    }
    // if (mapRef.current) {
    //   const currentZoom = mapRef.current.getZoom();
    //   const latOffset = 0.7 / Math.pow(2, (currentZoom - 4));
    //   mapRef.current.setCenter({
    //     lat: marker.lat - latOffset,
    //     lng: marker.lng,
    //   });
    // }
  };

  // Function to save shopper notes
  const saveShopperNotes = async (userId: any) => {
    try {
      const data = {
        userId: userId,
        shopperNotes: shopperNotes1,
      };
      const response = ApiPutShopperDetails(data);

      toast.success("Shopper notes saved successfully");
    } catch (error) {
      console.error("Error saving shopper notes:", error);
      toast.error("Error saving shopper notes");
    }
  };

  // Function to save training notes
  const saveTrainingNotes = async (userId: any) => {
    try {
      const data = {
        userId: userId,
        trainingNotes: trainingNotes,
      };
      const response = ApiPutShopperDetails(data);
      toast.success("Training notes saved successfully");
    } catch (error) {
      console.error("Error saving training notes:", error);
      toast.error("Error saving training notes");
    }
  };

  // Function to get shopper icon based on status and age
  const getShopperIcon = (status: string, age: string | null): string => {
    if (status === "active") {
      const ageNum = age ? Number.parseInt(age) : 0;
      if (ageNum >= 18 && ageNum <= 23) {
        return "https://mmfiles.s3.ap-southeast-2.amazonaws.com/ProjectFiles/PinBlue.png-04c76141-c916-46f3-a0b8-b9b6a57245d9"; // Blue pin
      } else {
        return "https://mmfiles.s3.ap-southeast-2.amazonaws.com/ProjectFiles/PinGreen.png-1339a1b4-3653-43ec-994f-c623c182e0b0"; // Pink pin
      }
    } else {
      return "https://mmfiles.s3.ap-southeast-2.amazonaws.com/ProjectFiles/PinRed.png-6c25052c-f163-4515-ad6c-bf5dae7c2fc3"; // Red pin
    }
  };
  const getVenueIcon = (clientGroupName: string) => {
    if (clientGroupName) {

      if (clientGroupName === 'ALDI') {
        return "https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image%20%281%29.png-2f692b6f-0d3e-49a9-b658-a70e98759edc";
      }
      else if (clientGroupName === 'BLOOMS') {
        return "https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image%20%282%29.png-6f906dfe-d33f-4d74-992e-b180c9f02fd8";
      }
      else if (clientGroupName === 'MM') {
        return "https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image.png-933eb71e-e9eb-404c-b8cc-322b4e0473d6";
      }
      else if (clientGroupName === 'JBHIFI') {
        return "https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image.png-933eb71e-e9eb-404c-b8cc-322b4e0473d6";
      }
      else if (clientGroupName === 'EXTENDED') {
        return "https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image.png-933eb71e-e9eb-404c-b8cc-322b4e0473d6";
      }
    };
  }

  const handleCheckboxChange =
    (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setCheckboxStates((prev) => ({
        ...prev,
        [name]: event.target.checked,
      }));
    };

  // Call API whenever checkbox states or selected states change
  useEffect(() => {
    const hasAnyCheckboxSelected = Object.values(checkboxStates).some(
      (value) => value
    );
    if (hasAnyCheckboxSelected || selectedState != "") {
      fetchMapData();
    } else {
      // Clear markers if no checkboxes are selected and no states selected
      setMapMarkers([]);
      setShopperMarkers([]);
    }
  }, [checkboxStates, selectedDate, selectedState, pending]);

  // Filter markers based on selected types
  const getFilteredMarkers = (): MapMarker[] => {
    let filteredVenues: MapMarker[] = [];
    let filteredShoppers: MapMarker[] = [];

    // Filter venue markers
    if (checkboxStates.showAldiAudit || checkboxStates.showAldiLiquorID) {
      filteredVenues = [
        ...filteredVenues,
        ...mapMarkers.filter((m) => m.type === "aldi"),
      ];
    }
    if (checkboxStates.showBloom) {
      filteredVenues = [
        ...filteredVenues,
        ...mapMarkers.filter((m) => m.type === "blooms"),
      ];
    }
    if (checkboxStates.showMM) {
      filteredVenues = [
        ...filteredVenues,
        ...mapMarkers.filter((m) => m.type === "mm"),
      ];
    }
    if (checkboxStates.showJbHifi) {
      filteredVenues = [
        ...filteredVenues,
        ...mapMarkers.filter((m) => m.type === "jbhifi"),
      ];
    }
    if (checkboxStates.showExtended) {
      filteredVenues = [
        ...filteredVenues,
        ...mapMarkers.filter((m) => m.type === "extended"),
      ];
    }

    // Filter shopper markers
    if (checkboxStates.shopperActive18) {
      filteredShoppers = [
        ...filteredShoppers,
        ...shopperMarkers.filter((m) => {
          const age = Number.parseInt(m.age) || 0;
          return m.type === "active" && age >= 18 && age <= 23;
        }),
      ];
    }
    if (checkboxStates.shopperActiveOther) {
      filteredShoppers = [
        ...filteredShoppers,
        ...shopperMarkers.filter((m) => {
          const age = Number.parseInt(m.age) || 0;
          return m.type === "active" && (age < 18 || age > 23);
        }),
      ];
    }
    if (checkboxStates.shopperInactive) {
      filteredShoppers = [
        ...filteredShoppers,
        ...shopperMarkers.filter((m) => m.type === "inActive"),
      ];
    }

    return [...filteredVenues, ...filteredShoppers];
  };

  if (loadError) {
    return <Typography color="error">Error loading Google Maps</Typography>;
  }

  if (!isLoaded) {
    return <Typography>Loading Google Maps...</Typography>;
  }

  const filteredMarkers = getFilteredMarkers();

  // Get the current selected marker object
  const currentMarker = selectedMarker

  const getTimeSinceCreated = (createdOn: string): string => {
    if (!createdOn) return "N/A";

    const createdDate = new Date(createdOn);
    const now = new Date();

    const diffYears = now.getFullYear() - createdDate.getFullYear();
    const diffMonths =
      (now.getFullYear() - createdDate.getFullYear()) * 12 +
      (now.getMonth() - createdDate.getMonth());

    if (diffYears >= 1) {
      return `${diffYears} year${diffYears > 1 ? "s" : ""} ago`;
    } else if (diffMonths >= 1) {
      return `${diffMonths} month${diffMonths > 1 ? "s" : ""} ago`;
    } else {
      return "Less than a month ago";
    }
  };

  const formatDate = (dateString: string): string => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };


  const handleOnFocus = (e: any) => {

    if (!staticLineInserted) {
      e.preventDefault(); // prevent newline from default action
      const now = new Date();
      const formatted = now.toLocaleString(); // e.g., 7/14/2025, 12:35:10 PM
      const staticLine = `${localStorage.getItem('userName')}-${formatted}:\n`
      const updatedText = `${staticLine}\n${shopperNotes1?.length > 1 ? `${shopperNotes1}\n` : ""}`; // add static line
      setShopperNotes1(updatedText);
      setStaticLineInserted(true);

      setTimeout(() => {
        const textarea = shoppernoteRef && shoppernoteRef.current;
        if (textarea) {
          textarea.focus(); // ensure focus
          textarea.setSelectionRange(staticLine.length, staticLine.length);
        }
      }, 0);

    }
  };
  const handleOnFocus2 = (e: any) => {
    if (!staticLineInserted2) {
      e.preventDefault(); // prevent newline from default action
      const now = new Date();
      const formatted = now.toLocaleString(); // e.g., 7/14/2025, 12:35:10 PM
      const staticLine = `${localStorage.getItem('userName')}-${formatted}:\n`
      const updatedText = `${staticLine}\n${trainingNotes?.length > 1 ? `${trainingNotes}\n` : ""}`; // add static line
      setTrainingNotes(updatedText);
      setStaticLineInserted2(true);

      setTimeout(() => {
        const textarea = trainingnoteRef && trainingnoteRef.current;
        if (textarea) {
          textarea.focus(); // ensure focus
          textarea.setSelectionRange(staticLine.length, staticLine.length);
        }
      }, 0);

    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ display: "flex", flexDirection:{xs:"column",md:'row'}, height: {xs:"fit-content",md:"calc(100vh - 80px)"}, overflow: {xs:"auto",md:"hidden"} }}>
        <Box
          sx={{
            width: {xs:"100%",md:280},
            minWidth: 250,
            backgroundColor: "#f9f9f9",
            p: 2,
            borderRight: "1px solid #ddd",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {/* State Autocomplete Dropdown */}
          <Box mb={0}>
            <Box mb={0}>
              <Autocomplete
                options={stateOptions}
                value={
                  stateOptions.find((state) => state.value === selectedState) ||
                  null
                }
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) => {
                  setSelectedState(newValue ? newValue.value : "");
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select State" fullWidth />
                )}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white",
                  },
                }}
              />
            </Box>
          </Box>
          <Grid item xs={12} sm={4}>
            <DatePicker
              label="Month/Year"
              views={["year", "month"]}
              value={selectedDate}
              onChange={setSelectedDate}
              slotProps={{ textField: { fullWidth: true } }}
            />
          </Grid>
          {/* Filter Card */}
          <Card sx={{ mb: 3 }}>
            <CardContent sx={{ p: 3 }}>
              <Grid container spacing={4} sx={{ justifyContent: "center" }}>
                {/* Left Column - Store/Client Groups (Scrollable Selection Area) */}
                <Grid item xs={12} sm={6} md={4}>
                  <Box 
                    sx={{ 
                      maxHeight: "180px", 
                      overflowY: "auto", 
                      display: "flex", 
                      flexDirection: "column", 
                      gap: 2,
                      pr: 1,
                      "&::-webkit-scrollbar": {
                        width: "6px"
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                        borderRadius: "4px"
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#ccc",
                        borderRadius: "4px"
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#999"
                      }
                    }}
                  >
                    {/* Aldi Stores */}
                    <Box display="flex" alignItems="center" gap={2}>
                      <Avatar sx={{ width: 32, height: 32 }}>
                        <img
                          src="https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image%20%281%29.png-2f692b6f-0d3e-49a9-b658-a70e98759edc"
                          alt="ALDI Audit"
                          style={{ width: 30, height: 30 }}
                        />
                      </Avatar>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxStates.showAldiAudit}
                            onChange={handleCheckboxChange("showAldiAudit")}
                            sx={{ color: "var(--AutumnOlive) !important" }}
                          />
                        }
                        label={
                          <Typography sx={{ color: "#666", fontWeight: 500 }}>
                            ALDI Audit
                          </Typography>
                        }
                      />
                    </Box>

                    {/* ALDI ID */}
                    <Box display="flex" alignItems="center" gap={2}>
                      <Avatar sx={{ width: 32, height: 32 }}>
                        <img
                          src="https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image%20%281%29.png-2f692b6f-0d3e-49a9-b658-a70e98759edc"
                          alt="ALDI ID"
                          style={{ width: 30, height: 30 }}
                        />
                      </Avatar>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxStates.showAldiLiquorID}
                            onChange={handleCheckboxChange("showAldiLiquorID")}
                            sx={{ color: "var(--AutumnOlive) !important" }}
                          />
                        }
                        label={
                          <Typography sx={{ color: "#666", fontWeight: 500 }}>
                            ALDI ID
                          </Typography>
                        }
                      />
                    </Box>

                    {/* Bloom Stores */}
                    <Box display="flex" alignItems="center" gap={2}>
                      <Avatar sx={{ width: 32, height: 32 }}>
                        <img
                          src="https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image%20%282%29.png-6f906dfe-d33f-4d74-992e-b180c9f02fd8"
                          alt="BLOOM"
                          style={{ width: 30, height: 30 }}
                        />
                      </Avatar>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxStates.showBloom}
                            onChange={handleCheckboxChange("showBloom")}
                            sx={{ color: "var(--AutumnOlive) !important" }}
                          />
                        }
                        label={
                          <Typography sx={{ color: "#666", fontWeight: 500 }}>
                            BLOOMS Stores
                          </Typography>
                        }
                      />
                    </Box>

                    {/* MM Stores */}
                    <Box display="flex" alignItems="center" gap={2}>
                      <Avatar sx={{ width: 32, height: 32 }}>
                        <img
                          src="https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image.png-933eb71e-e9eb-404c-b8cc-322b4e0473d6"
                          alt="MM"
                          style={{ width: 30, height: 30 }}
                        />
                      </Avatar>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxStates.showMM}
                            onChange={handleCheckboxChange("showMM")}
                            sx={{ color: "var(--AutumnOlive) !important" }}
                          />
                        }
                        label={
                          <Typography sx={{ color: "#666", fontWeight: 500 }}>
                            MM Stores
                          </Typography>
                        }
                      />
                    </Box>

                    {/* JB-HIFI Stores */}
                    <Box display="flex" alignItems="center" gap={2}>
                      <Avatar sx={{ width: 32, height: 32 }}>
                        <img
                          src="https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image.png-933eb71e-e9eb-404c-b8cc-322b4e0473d6"
                          alt="JB-HIFI"
                          style={{ width: 30, height: 30 }}
                        />
                      </Avatar>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxStates.showJbHifi}
                            onChange={handleCheckboxChange("showJbHifi")}
                            sx={{ color: "var(--AutumnOlive) !important" }}
                          />
                        }
                        label={
                          <Typography sx={{ color: "#666", fontWeight: 500 }}>
                            JB-HIFI Stores
                          </Typography>
                        }
                      />
                    </Box>

                    {/* EXTENDED Stores */}
                    <Box display="flex" alignItems="center" gap={2}>
                      <Avatar sx={{ width: 32, height: 32 }}>
                        <img
                          src="https://mmfiles.s3.ap-southeast-2.amazonaws.com/ShopperFiles/ProfilePictures/profilepic-1-image.png-933eb71e-e9eb-404c-b8cc-322b4e0473d6"
                          alt="EXTENDED"
                          style={{ width: 30, height: 30 }}
                        />
                      </Avatar>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxStates.showExtended}
                            onChange={handleCheckboxChange("showExtended")}
                            sx={{ color: "var(--AutumnOlive) !important" }}
                          />
                        }
                        label={
                          <Typography sx={{ color: "#666", fontWeight: 500 }}>
                            EXTENDED Stores
                          </Typography>
                        }
                      />
                    </Box>
                  </Box>
                </Grid>

                {/* Right Column - Shopper Categories */}
                <Grid item xs={12} sm={6} md={4}>
                  <Box display="flex" flexDirection="column" gap={2}>
                    {/* Shoppers - Active (18-22) */}
                    <Box display="flex" alignItems="center" gap={2}>
                      <Avatar sx={{ width: 32, height: 32 }}>
                        <img
                          src="https://mmfiles.s3.ap-southeast-2.amazonaws.com/ProjectFiles/PinBlue.png-04c76141-c916-46f3-a0b8-b9b6a57245d9"
                          alt="Shopper_active(18-22)"
                          style={{ width: 30, height: 30 }}
                        />
                      </Avatar>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxStates.shopperActive18}
                            onChange={handleCheckboxChange("shopperActive18")}
                            sx={{ color: "var(--AutumnOlive) !important" }}
                          />
                        }
                        label={
                          <Typography sx={{ color: "#666", fontWeight: 500 }}>
                            Shoppers - Active (18-23)
                          </Typography>
                        }
                      />
                    </Box>

                    {/* Shoppers - Active (Other Remaining) */}
                    <Box display="flex" alignItems="center" gap={2}>
                      <Avatar sx={{ width: 32, height: 32 }}>
                        <img
                          src="https://mmfiles.s3.ap-southeast-2.amazonaws.com/ProjectFiles/PinGreen.png-1339a1b4-3653-43ec-994f-c623c182e0b0"
                          alt="Shopper_active"
                          style={{ width: 30, height: 30 }}
                        />
                      </Avatar>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxStates.shopperActiveOther}
                            onChange={handleCheckboxChange("shopperActiveOther")}
                            sx={{ color: "var(--AutumnOlive) !important" }}
                          />
                        }
                        label={
                          <Typography sx={{ color: "#666", fontWeight: 500 }}>
                            Shoppers - Active (Other Remaining)
                          </Typography>
                        }
                      />
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box display="flex" flexDirection="column" gap={2}>
                    {/* Shoppers - InActive */}
                    <Box display="flex" alignItems="center" gap={2}>
                      <Avatar sx={{ width: 32, height: 32 }}>
                        <img
                          src="https://mmfiles.s3.ap-southeast-2.amazonaws.com/ProjectFiles/PinRed.png-6c25052c-f163-4515-ad6c-bf5dae7c2fc3"
                          alt="Shopper_inActive"
                          style={{ width: 30, height: 30 }}
                        />
                      </Avatar>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxStates.shopperInactive}
                            onChange={handleCheckboxChange("shopperInactive")}
                            sx={{ color: "var(--AutumnOlive) !important" }}
                          />
                        }
                        label={
                          <Typography sx={{ color: "#666", fontWeight: 500 }}>
                            Shoppers - InActive
                          </Typography>
                        }
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", p: 2, overflow: {xs:"auto",md:"hidden"} }}>
          <Box className="d-flex align-items-center justify-content-between" mb={2} sx={{ flexWrap: 'wrap', gap: 2 }}>
            <GoogleAutocomplete
              onLoad={(autocomplete) => {
                setAutocomplete(autocomplete);
              }}
              onPlaceChanged={() => {
                if (autocomplete) {
                  const place = autocomplete.getPlace();
                  if (place.geometry && place.geometry.location) {
                    const location = {
                      lat: place.geometry.location.lat(),
                      lng: place.geometry.location.lng(),
                    };
                    setcentermap(location);

                    if (mapRef.current) {
                      mapRef.current.setCenter(location);
                      mapRef.current.setZoom(15);
                    }

                    setSearchResult(place.formatted_address || "");
                  }
                }
              }}
              options={{
                types: ["geocode"],
                componentRestrictions: { country: "au" },
              }}
            >
              <TextField
                fullWidth
                placeholder="Search for a location in Australia"
                variant="outlined"
                value={searchResult}
                onChange={(e) => setSearchResult(e.target.value)}
                sx={{
                  flex: 1,
                  minWidth: { xs: "100%", sm: "250px", md: "400px" },
                  maxWidth: { xs: "100%", md: "800px", lg: "1500px" },
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
              />
            </GoogleAutocomplete>
            <Box className="d-flex align-items-center" gap={2}>
              <p className="mb-1">All</p>
              <FormGroup>
                <FormControlLabel control={<Switch checked={pending} onChange={() => { setPending(!pending) }} />} label="Orphans" />
              </FormGroup>
            </Box>
          </Box>
          <Box sx={{ flex: 1, minHeight: 0 }}>
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={centermap}
              onLoad={(map) => {
                // mapRef.current = map;
                onMapLoad(map)
              }}
              zoom={searchResult ? 4 : 4}
              options={{
                gestureHandling: "greedy",
                scrollwheel: true,
                zoomControl: true
              }}
            >
              {filteredMarkers.map((marker) => (
                <Marker
                  key={`${marker.entityName}-${marker.id}-${marker.lat}-${marker.lng}-${marker.index}`}
                  position={{ lat: marker.lat, lng: marker.lng }}
                  onLoad={(markerInstance) => {
                    if (omsRef.current) {
                      markerInstance.customData = marker;
                      omsRef.current.addMarker(markerInstance);
                    }
                  }}
                  icon={{
                    url: marker.logo,
                    scaledSize: new window.google.maps.Size(40, 40),
                  }}
                >
                  {selectedMarker &&
                    selectedMarker.id === marker.id &&
                    selectedMarker.entityName === marker.entityName && (
                    <InfoWindow
                      position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
                      onCloseClick={() => {
                        setSelectedMarker(null);
                        if (omsRef.current) {
                          omsRef.current.unspiderfy();
                        }
                      }}
                    >
                      <div
                        onWheel={(e) => e.stopPropagation()}
                        onMouseDown={(e) => e.stopPropagation()}
                        onTouchStart={(e) => e.stopPropagation()}
                        style={{
                          backgroundColor: "white",
                          padding: "8px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                          minWidth: "300px",
                          maxWidth: "400px",
                          maxHeight: "500px",
                          overflowY: "auto",
                          position: "relative",
                        }}
                      >
                        <button
                          onClick={() => {
                            setSelectedMarker(null);
                            if (omsRef.current) {
                              omsRef.current.unspiderfy();
                            }
                          }}
                          style={{
                            position: "absolute",
                            top: 4,
                            right: 4,
                            background: "transparent",
                            border: "none",
                            fontSize: "25px",
                            cursor: "pointer",
                            zIndex: 10,
                          }}
                        >
                          ✕
                        </button>

                        {marker.entityName === "Shopper" ? (
                          <div style={{ fontFamily: "Arial, sans-serif" }}>
                            {loadingShopperDetails ? (
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="200px"
                              >
                                <CircularProgress size={40} />
                                <Typography sx={{ ml: 2 }}>
                                  Loading shopper details...
                                </Typography>
                              </Box>
                            ) : (
                              <>
                                <div
                                  style={{
                                    backgroundColor: "#f5f5f5",
                                    padding: "8px",
                                    marginBottom: "12px",
                                    border: "1px solid #ccc",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    fontWeight="bold"
                                    sx={{ mb: 1 }}
                                  >
                                    Contact Details:
                                  </Typography>
                                  <div
                                    style={{
                                      display: "grid",
                                      gridTemplateColumns: "60px 1fr",
                                      gap: "4px",
                                      fontSize: "12px",
                                    }}
                                  >
                                    <div style={{ fontWeight: "bold" }}>Name:</div>
                                    <div
                                      style={{
                                        border: "1px solid #ccc",
                                        padding: "2px 4px",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      {`${shopperDetails?.firstName || ""} ${shopperDetails?.lastName || ""}`.trim() || "N/A"}

                                    </div>
                                    <div style={{ fontWeight: "bold" }}>Age:</div>
                                    <div
                                      style={{
                                        border: "1px solid #ccc",
                                        padding: "2px 4px",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      {shopperDetails?.contactDetails?.age ||
                                        currentMarker?.age ||
                                        "N/A"}
                                    </div>
                                    <div style={{ fontWeight: "bold" }}>
                                      Email:
                                    </div>
                                    <div
                                      style={{
                                        border: "1px solid #ccc",
                                        padding: "2px 4px",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      {shopperDetails?.contactDetails?.email ||
                                        currentMarker?.emailId ||
                                        "N/A"}
                                    </div>
                                    <div style={{ fontWeight: "bold" }}>
                                      Phone:
                                    </div>
                                    <div
                                      style={{
                                        border: "1px solid #ccc",
                                        padding: "2px 4px",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      {shopperDetails?.contactDetails?.phone ||
                                        currentMarker?.contactNo ||
                                        "N/A"}
                                    </div>
                                  </div>
                                </div>

                                <div style={{ marginBottom: "12px" }}>
                                  <Typography
                                    variant="subtitle2"
                                    fontWeight="bold"
                                    sx={{ mb: 1 }}
                                  >
                                    This month allocations
                                  </Typography>
                                  <div
                                    style={{
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr 1fr",
                                        backgroundColor: "#8B9467",
                                        color: "white",
                                        fontSize: "11px",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          padding: "4px",
                                          borderRight: "1px solid #fff",
                                        }}
                                      >
                                        MM
                                      </div>
                                      <div
                                        style={{
                                          padding: "4px",
                                          borderRight: "1px solid #fff",
                                        }}
                                      >
                                        BLOOMS
                                      </div>
                                      <div
                                        style={{
                                          padding: "4px",
                                          borderRight: "1px solid #fff",
                                        }}
                                      >
                                        ALDI
                                      </div>
                                      <div style={{ padding: "4px" }}>
                                        Transport
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr 1fr",
                                        backgroundColor: "white",
                                        fontSize: "11px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          padding: "4px",
                                          borderRight: "1px solid #ccc",
                                        }}
                                      >
                                        {shopperDetails
                                          ?.currentMonthAllocationCounts?.MM || 0}
                                      </div>
                                      <div
                                        style={{
                                          padding: "4px",
                                          borderRight: "1px solid #ccc",
                                        }}
                                      >
                                        {shopperDetails
                                          ?.currentMonthAllocationCounts
                                          ?.BLOOMS || 0}
                                      </div>
                                      <div
                                        style={{
                                          padding: "4px",
                                          borderRight: "1px solid #ccc",
                                        }}
                                      >
                                        {shopperDetails
                                          ?.currentMonthAllocationCounts?.ALDI ||
                                          0}
                                      </div>
                                      <div style={{ padding: "4px" }}>
                                        {shopperDetails
                                          ?.currentMonthAllocationCounts
                                          ?.TRANSPORT || 0}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div style={{ marginBottom: "12px" }}>
                                  <Typography
                                    variant="subtitle2"
                                    fontWeight="bold"
                                    sx={{ mb: 1 }}
                                  >
                                    Shopper History:
                                  </Typography>
                                  <div
                                    style={{
                                      border: "1px solid #ccc",
                                      borderRadius: "4px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: "#f0f0f0",
                                        padding: "4px 8px",
                                        fontSize: "12px",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                      }}
                                    >
                                      {shopperDetails?.totalReportCounts?.total ||
                                        0}{" "}
                                      Reports
                                    </div>
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr 1fr",
                                        backgroundColor: "#8B9467",
                                        color: "white",
                                        fontSize: "11px",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          padding: "4px",
                                          borderRight: "1px solid #fff",
                                        }}
                                      >
                                        ALDI
                                      </div>
                                      <div
                                        style={{
                                          padding: "4px",
                                          borderRight: "1px solid #fff",
                                        }}
                                      >
                                        BLOOMS
                                      </div>
                                      <div
                                        style={{
                                          padding: "4px",
                                          borderRight: "1px solid #fff",
                                        }}
                                      >
                                        MM
                                      </div>
                                      <div style={{ padding: "4px" }}>Beacon</div>
                                    </div>
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr 1fr 1fr",
                                        backgroundColor: "white",
                                        fontSize: "11px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          padding: "4px",
                                          borderRight: "1px solid #ccc",
                                        }}
                                      >
                                        {shopperDetails?.totalReportCounts
                                          ?.ALDI || 0}
                                      </div>
                                      <div
                                        style={{
                                          padding: "4px",
                                          borderRight: "1px solid #ccc",
                                        }}
                                      >
                                        {shopperDetails?.totalReportCounts
                                          ?.BLOOMS || 0}
                                      </div>
                                      <div
                                        style={{
                                          padding: "4px",
                                          borderRight: "1px solid #ccc",
                                        }}
                                      >
                                        {shopperDetails?.totalReportCounts?.MM ||
                                          0}
                                      </div>
                                      <div style={{ padding: "4px" }}>
                                        {shopperDetails?.totalReportCounts
                                          ?.beacon || 0}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    flex: "1",
                                    fontSize: "12px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    overflow: "hidden",
                                    marginBottom: "12px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "grid",
                                      gridTemplateColumns: "1fr 1fr",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: "#8B9467",
                                        color: "white",
                                        padding: "4px",
                                        fontWeight: "bold",
                                        borderBottom: "1px solid #ccc",
                                        borderRight: "1px solid #ccc",
                                      }}
                                    >
                                      Member Since:
                                    </div>
                                    <div
                                      style={{
                                        padding: "4px",
                                        backgroundColor: "white",
                                        borderBottom: "1px solid #ccc",
                                      }}
                                    >
                                      {getTimeSinceCreated(
                                        shopperDetails?.createdOn
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        backgroundColor: "#8B9467",
                                        color: "white",
                                        padding: "4px",
                                        fontWeight: "bold",
                                        borderBottom: "1px solid #ccc",
                                        borderRight: "1px solid #ccc",
                                      }}
                                    >
                                      Last Report Rating:
                                    </div>
                                    <div
                                      style={{
                                        padding: "4px",
                                        backgroundColor: "white",
                                        borderBottom: "1px solid #ccc",
                                      }}
                                    >
                                      <div>
                                        {shopperDetails?.lastReportRatingData?.MM
                                          ?.reportCreatedDate
                                          ? `MM -- ${shopperDetails.lastReportRatingData
                                            .MM.reportMonth
                                          }/${shopperDetails.lastReportRatingData
                                            .MM.reportYear
                                          } -- ${formatDate(
                                            shopperDetails.lastReportRatingData
                                              .MM.submitDate
                                          )} -- ${shopperDetails.lastReportRatingData
                                            .MM.score
                                          }/100`
                                          : "MM -- N/A"}
                                      </div>
                                      <div>
                                        {shopperDetails?.lastReportRatingData
                                          ?.ALDI?.reportCreatedDate
                                          ? `ALDI -- ${shopperDetails.lastReportRatingData
                                            .ALDI.reportMonth
                                          }/${shopperDetails.lastReportRatingData
                                            .ALDI.reportYear
                                          } -- ${formatDate(
                                            shopperDetails.lastReportRatingData
                                              .ALDI.submitDate
                                          )} -- ${shopperDetails.lastReportRatingData
                                            .ALDI.score
                                          }/100`
                                          : "ALDI -- N/A"}
                                      </div>
                                      <div>
                                        {shopperDetails?.lastReportRatingData
                                          ?.BLOOMS?.reportCreatedDate
                                          ? `BLOOMS -- ${shopperDetails.lastReportRatingData
                                            .BLOOMS.reportMonth
                                          }/${shopperDetails.lastReportRatingData
                                            .BLOOMS.reportYear
                                          } -- ${formatDate(
                                            shopperDetails.lastReportRatingData
                                              .BLOOMS.submitDate
                                          )} -- ${shopperDetails.lastReportRatingData
                                            .BLOOMS.score
                                          }/100`
                                          : "BLOOMS -- N/A"}
                                      </div>
                                    </div>

                                    <div
                                      style={{
                                        backgroundColor: "#8B9467",
                                        color: "white",
                                        padding: "4px",
                                        fontWeight: "bold",
                                        borderBottom: "1px solid #ccc",
                                        borderRight: "1px solid #ccc",
                                      }}
                                    >
                                      Last Month:
                                    </div>
                                    <div
                                      style={{
                                        padding: "4px",
                                        backgroundColor: "white",
                                        borderBottom: "1px solid #ccc",
                                      }}
                                    >
                                      {`${shopperDetails?.totalReportCounts?.totalLastMonthReportCounts} Reports` ||
                                        "0 Reports"}
                                    </div>
                                    <div
                                      style={{
                                        backgroundColor: "#8B9467",
                                        color: "white",
                                        padding: "4px",
                                        fontWeight: "bold",
                                        borderBottom: "1px solid #ccc",
                                        borderRight: "1px solid #ccc",
                                      }}
                                    >
                                      Overall Rating:
                                    </div>
                                    <div
                                      style={{
                                        padding: "4px",
                                        backgroundColor: "white",
                                        borderBottom: "1px solid #ccc",
                                      }}
                                    >
                                      {shopperDetails?.shopperOverAllRating ||
                                        "N/A"}
                                    </div>
                                    <div
                                      style={{
                                        backgroundColor: "#8B9467",
                                        color: "white",
                                        padding: "4px",
                                        fontWeight: "bold",
                                        borderRight: "1px solid #ccc",
                                      }}
                                    >
                                      Editor's Comment:
                                    </div>
                                    <div
                                      style={{
                                        padding: "6px",
                                        backgroundColor: "white",
                                        fontSize: "11px",
                                        minHeight: "60px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {[
                                        shopperDetails?.lastReportRatingData?.MM,
                                        shopperDetails?.lastReportRatingData
                                          ?.ALDI,
                                        shopperDetails?.lastReportRatingData
                                          ?.BLOOMS,
                                      ]
                                        .filter((r) => r?.submitDate)
                                        .sort(
                                          (a, b) =>
                                            new Date(b.submitDate).getTime() -
                                            new Date(a.submitDate).getTime()
                                        )[0]?.editorComment ||
                                        "No comments available"}
                                    </div>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    marginBottom: "12px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      backgroundColor: "#8B9467",
                                      color: "white",
                                      padding: "4px",
                                      fontWeight: "bold",
                                      fontSize: "12px",
                                    }}
                                  >
                                    Shopper Notes
                                  </div>
                                  <div
                                    style={{
                                      padding: "6px",
                                      backgroundColor: "#f5f5f5",
                                    }}
                                  >
                                    <textarea
                                      ref={shoppernoteRef}
                                      value={shopperNotes1}
                                      onMouseDown={(e) => e.stopPropagation()}
                                      onKeyDown={(e) => e.stopPropagation()}
                                      onFocus={(e) => { e.stopPropagation(); handleOnFocus(e) }}
                                      onClick={(e) => e.stopPropagation()}
                                      onChange={(e) =>
                                        setShopperNotes1(e.target.value)
                                      }
                                      style={{
                                        width: "100%",
                                        border: "1px solid #ccc",
                                        padding: "6px",
                                        backgroundColor: "white",
                                        fontSize: "11px",
                                        minHeight: "40px",
                                        marginBottom: "4px",
                                        resize: "vertical",
                                        fontFamily: "Arial, sans-serif",
                                      }}
                                    />
                                    <button
                                      onClick={() =>
                                        saveShopperNotes(shopperDetails.userId)
                                      }
                                      style={{
                                        backgroundColor: "#8B9467",
                                        color: "white",
                                        border: "none",
                                        padding: "4px 12px",
                                        borderRadius: "4px",
                                        fontSize: "11px",
                                        cursor: "pointer",
                                        width: "100%",
                                      }}
                                    >
                                      Save shopper notes
                                    </button>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      backgroundColor: "#8B9467",
                                      color: "white",
                                      padding: "4px",
                                      fontWeight: "bold",
                                      fontSize: "12px",
                                    }}
                                  >
                                    Training Notes
                                  </div>
                                  <div
                                    style={{
                                      padding: "6px",
                                      backgroundColor: "#f5f5f5",
                                    }}
                                  >
                                    <textarea
                                      value={trainingNotes}
                                      ref={trainingnoteRef}
                                      onMouseDown={(e) => e.stopPropagation()}
                                      onKeyDown={(e) => e.stopPropagation()}
                                      onFocus={(e) => { e.stopPropagation(); handleOnFocus2(e) }}
                                      onClick={(e) => e.stopPropagation()}
                                      onChange={(e) =>
                                        setTrainingNotes(e.target.value)
                                      }
                                      style={{
                                        width: "100%",
                                        border: "1px solid #ccc",
                                        padding: "6px",
                                        backgroundColor: "white",
                                        fontSize: "11px",
                                        minHeight: "40px",
                                        marginBottom: "6px",
                                        resize: "vertical",
                                        fontFamily: "Arial, sans-serif",
                                      }}
                                    />
                                    <button
                                      onClick={() =>
                                        saveTrainingNotes(shopperDetails.userId)
                                      }
                                      style={{
                                        backgroundColor: "#8B9467",
                                        color: "white",
                                        border: "none",
                                        padding: "4px 12px",
                                        borderRadius: "4px",
                                        fontSize: "11px",
                                        cursor: "pointer",
                                        width: "100%",
                                      }}
                                    >
                                      Save Training Notes
                                    </button>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        ) : (
                          <div>
                            {loadingVenueDetails ? (
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="200px"

                              >
                                <CircularProgress size={40} />
                                <Typography sx={{ ml: 2 }}>
                                  Loading venue details...
                                </Typography>
                              </Box>
                            ) : (
                              <div>
                                <Typography
                                  variant="h6"
                                  fontWeight="bold"
                                  sx={{ mb: 1 }}
                                >
                                  {marker.name}
                                </Typography>
                                <Typography
                                  variant="body1"
                                  sx={{ mb: 2, fontWeight: 500 }}
                                >
                                  Fees: {marker.venuePriceDisplay}
                                </Typography>

                                <Typography
                                  variant="subtitle2"
                                  fontWeight="bold"
                                  sx={{ mb: 1 }}
                                >
                                  Previous Reports:
                                </Typography>

                                <Box
                                  sx={{
                                    border: "1px solid #ddd",
                                    borderRadius: 1,
                                    overflow: "hidden",
                                    fontFamily: "Roboto, sans-serif", // Optional: consistent font
                                  }}
                                >
                                  {/* Table Header */}
                                  <Box
                                    sx={{
                                      display: "grid",
                                      gridTemplateColumns: "repeat(5, 1fr)",
                                      backgroundColor: "#8B9467",
                                      color: "white",
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                      borderBottom: "1px solid #ddd",
                                    }}
                                  >
                                    {[
                                      "Month",
                                      "Shopper",
                                      "Age",
                                      "Phone",
                                      "Score",
                                    ].map((header, i) => (
                                      <Box
                                        key={header}
                                        sx={{
                                          p: 1,
                                          borderRight:
                                            i < 4 ? "1px solid #fff" : "none",
                                        }}
                                      >
                                        {header}
                                      </Box>
                                    ))}
                                  </Box>

                                  {/* Table Rows */}
                                  {venueDetails?.map((report: any, index: any) => (
                                    <Box
                                      key={index}
                                      sx={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(5, 1fr)",
                                        backgroundColor:
                                          index % 2 === 0 ? "#f9f9f9" : "white",
                                        fontSize: "11px",
                                        borderBottom: "1px solid #ddd",
                                      }}
                                    >
                                      {[
                                        report.reportMonth,
                                        report.userName,
                                        report.age,
                                        report.contactNo,
                                        report.finalScore,
                                      ].map((val, i) => (
                                        <Box
                                          key={i}
                                          sx={{
                                            // whiteSpace:'nowrap',
                                            p: 1,
                                            borderRight:
                                              i < 4 ? "1px solid #ddd" : "none",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {val}
                                        </Box>
                                      ))}
                                    </Box>
                                  ))}

                                  {/* Optional: Fallback message */}
                                  {(!venueDetails ||
                                    venueDetails.length === 0) && (
                                      <Box
                                        sx={{
                                          p: 2,
                                          textAlign: "center",
                                          fontSize: "12px",
                                          color: "#666",
                                        }}
                                      >
                                        No previous reports available
                                      </Box>
                                    )}
                                </Box>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </InfoWindow>
                  )}
                </Marker>
              ))}
            </GoogleMap>
          </Box>
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default ShopperVenueMap;